import { useEffect, useState } from 'react';

// The room's sound bed, Web Audio, no samples: one tick per request bead
// landing (pitch by status), a lower tone per probe round trip, a soft
// chime when a deploy finishes, a low beat when the containers are
// sampled. Off by default; `M` toggles; the choice is remembered.
const AUDIO_KEY = 'nv.room.audio';
let actx = null;
const audioState = { muted: (() => { try { return localStorage.getItem(AUDIO_KEY) !== 'on'; } catch { return true; } })(), listeners: new Set() };
const ctx = () => {
  if (!actx) { const AC = window.AudioContext || window.webkitAudioContext; actx = AC ? new AC() : null; }
  if (actx?.state === 'suspended') actx.resume().catch(() => {});
  return actx;
};
function blip(freq, ms, gain = 0.05, type = 'sine') {
  if (audioState.muted) return;
  const c = ctx(); if (!c) return;
  const o = c.createOscillator(); const g = c.createGain();
  o.type = type; o.frequency.value = freq;
  g.gain.setValueAtTime(0, c.currentTime);
  g.gain.linearRampToValueAtTime(gain, c.currentTime + 0.005);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + ms / 1000);
  o.connect(g); g.connect(c.destination); o.start(); o.stop(c.currentTime + ms / 1000 + 0.02);
}
let lastTick = 0;
export const roomAudio = {
  get muted() { return audioState.muted; },
  toggle() {
    audioState.muted = !audioState.muted;
    try { localStorage.setItem(AUDIO_KEY, audioState.muted ? 'off' : 'on'); } catch { /* ignore */ }
    if (!audioState.muted) ctx();
    audioState.listeners.forEach((f) => f(audioState.muted));
  },
  tick(status = 200) { const now = performance.now(); if (now - lastTick < 40) return; lastTick = now; blip(status >= 500 ? 220 : status >= 400 ? 440 : 1760, 40, 0.03, status >= 500 ? 'square' : 'sine'); },
  probe(ok = true) { blip(ok ? 330 : 165, 160, 0.05); },
  chime() { blip(660, 220, 0.05); setTimeout(() => blip(990, 300, 0.05), 120); },
  beat() { blip(110, 90, 0.02); },
};
export function useRoomAudio() {
  const [muted, setMuted] = useState(audioState.muted);
  useEffect(() => { audioState.listeners.add(setMuted); return () => audioState.listeners.delete(setMuted); }, []);
  return { muted, toggle: roomAudio.toggle };
}
